import { Injectable } from '@angular/core';
import { BudgetClassificationCodeFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-classification-code/budget-classification-code-find-many-query.dto';
import { BudgetClassificationCodeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-classification-code/budget-classification-code-find.dto';
import { BudgetClassificationCodePageInterface } from '@zaoblako/shared/modules/catalog/dtos/budget-classification-code/budget-classification-code-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BudgetClassificationCodeService extends BaseService {
  protected baseUrl = '/basis/catalog/budget-classification-code';

  public findWithPagination(
    queryParams: BudgetClassificationCodeFindManyQueryInterface
  ): Observable<BudgetClassificationCodePageInterface> {
    return this.http.get<BudgetClassificationCodePageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<BudgetClassificationCodeFindInterface> {
    return this.http.post<BudgetClassificationCodeFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }
}
